import React from "react"
import { useTranslation, useLanguageQuery } from "next-export-i18n"

const Privacy = () => {
  const { t } = useTranslation()
  const [query] = useLanguageQuery()
  return (
    <div className="w-full bg-lightBlue">
      <div className="max-w-7xl mx-auto px-4 py-10 md:py-14">
        <h2 className="text-woundTextDark text-xl md:text-2xl xl:text-2xl pb-3  text-center  font-semibold   ">
          Use and disclosure of personal health information
        </h2>
        <p className=" text-base xl:text-xl pb-4  text-center md:text-left font-normal  ">
          Carea may use and disclose your personal health information to provide
          you with health care and services, including sharing your health
          information with Carea team members who are directly involved in your
          care. At Carea, physicians, nurses, social workers, community workers
          and support staff work together to provide high quality services to
          you and to the community. Your personal health information may be
          shared amongst the members who are directly involved in your care in
          order to be able to help you most effectively.
        </p>
        <p className="text-base xl:text-xl pb-4  text-center md:text-left font-normal  ">
          Carea may also use and disclose your personal health information for
          other reasons such as:
        </p>
        <ul className="px-6 md:px-16 list-disc text-base xl:text-xl md:pb-4  text-center md:text-left font-normal  ">
          <li className="py-2">
            To receive payment for your treatment and care (from OHIP, WSIB,
            your private health insurer, or others as the law permits).
          </li>
          <li className="py-2">
            To plan, administer and manage our operations.
          </li>
          <li className="py-2">
            To conduct risk management and quality improvement activities (such
            as client satisfaction surveys, complaint follow-up).
          </li>
          <li className="py-2">For teaching (such as staff training).</li>
          <li className="py-2">
            To comply with legal and regulatory requirements, and fulfill other
            purposes permitted or required by law.
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Privacy
